import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// Import Tailwind CSS
import './assets/css/main.css';

// Initialize Firebase
import './firebase/config';

// Initialize global authentication
import { initializeGlobalAuth } from './composables/useAuth';
import { initializeAdminAuth } from './composables/useAdmin';

// Import test utilities for development
if (process.env.NODE_ENV === 'development') {
  import('./utils/createTestBlogPost');
  import('./utils/createTestBlogCategory');
}

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(pinia);

// Initialize SEO
import { seoInitializer } from './utils/seoInit';
import { useConsentStore } from './stores/consentStore';
import { useAnalytics } from './composables/useAnalytics';

// Initialize authentication and SEO before mounting
const initializeApp = async () => {
  await initializeGlobalAuth();
  await initializeAdminAuth();
  
  // Initialize SEO components
  await seoInitializer.initialize();

  // Wire router page view tracking (respecting user consent)
  try {
    const consentStore = useConsentStore();
    const analytics = useAnalytics();

    router.afterEach((to) => {
      // Only track if analytics is allowed by consent
      if (consentStore.canUseAnalytics) {
        // Track page view using composable
        analytics.trackEvent('page_view', { category: 'navigation', label: to.fullPath });
      }
    });
  } catch (err) {
    // No-op if stores aren't available during SSR or early init
    // Analytics is best-effort and should not block mount
  }
  
  app.mount('#app');
};

initializeApp();
